import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiTarget,FiDollarSign,FiClock,FiTrendingUp,FiUsers,FiZap}=FiIcons;

const Benefits=()=> {
  const benefits=[
    {
      icon: FiTarget,
      title: "Targeted Growth Strategy",
      description: "Get a clear roadmap tailored to your business type and goals, eliminating guesswork and wasted effort."
    },
    {
      icon: FiDollarSign,
      title: "Increase Revenue",
      description: "Our proven system helps businesses increase their revenue. Some business owners see a 40% increase within the first 90 days."
    },
    {
      icon: FiClock,
      title: "Save 20+ Hours Weekly",
      description: "Streamline your marketing efforts with our templates and automation guides, freeing up time for what matters most."
    },
    {
      icon: FiTrendingUp,
      title: "Sustainable Growth",
      description: "Build systems that work long-term, creating consistent growth that doesn't require constant hands-on management."
    },
    {
      icon: FiUsers,
      title: "Expert Community",
      description: "Connect with like-minded entrepreneurs and get guidance from business growth experts in our weekly calls."
    },
    {
      icon: FiZap,
      title: "Quick Implementation",
      description: "Start seeing results in as little as 7 days with our step-by-step implementation guides and templates."
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Business Owners Choose
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent block">
              Circle of Goodness<sup className="text-sm">TM</sup>
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join hundreds of successful entrepreneurs who've transformed their businesses
            with our comprehensive growth system.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              transition={{duration: 0.6,delay: index * 0.1}}
              viewport={{once: true}}
              className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group hover:scale-105"
            >
              <div className="bg-gradient-to-r from-blue-600 to-purple-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <SafeIcon icon={benefit.icon} className="text-white text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.8,delay: 0.6}}
          viewport={{once: true}}
          className="text-center mt-16"
        >
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8 rounded-2xl shadow-2xl max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Ready to Transform Your Business?
            </h3>
            <p className="text-xl mb-6 opacity-90">
              Start your free 7-day trial and discover why successful entrepreneurs
              trust Circle of Goodness<sup className="text-xs">TM</sup> for their growth.
            </p>
            <button
              onClick={()=> document.getElementById('signup-form').scrollIntoView({behavior: 'smooth'})}
              className="bg-white text-blue-600 font-bold px-8 py-4 rounded-full hover:bg-gray-100 transition-colors duration-300 shadow-lg"
            >
              Get Started Now - It's FREE
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;